/* PUSHAS Journal v2 interactions */
(function(){
  var root=document.querySelector('.pj'); if(!root) return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Headline mask reveal
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-ready'); }); });

  // Scroll reveal
  var els=[].slice.call(root.querySelectorAll('.pj-reveal'));
  if(reduce || !('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in')}); }
  else{
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(e){ io.observe(e); });
  }

  // Tabs sliding indicator
  var tabs=root.querySelector('.pj-tabs');
  if(tabs){
    var ind=tabs.querySelector('.pj-tabs-ind'), cur=tabs.querySelector('[aria-current=page]');
    var place=function(el){ if(!el||!ind) return; ind.style.width=el.offsetWidth+'px'; ind.style.transform='translateX('+el.offsetLeft+'px)'; };
    place(cur); window.addEventListener('resize',function(){place(cur)},{passive:true});
    [].forEach.call(tabs.querySelectorAll('a'),function(a){ a.addEventListener('mouseenter',function(){place(a)}); });
    tabs.addEventListener('mouseleave',function(){place(cur)});
  }

  // Cursor bubble over story cards
  if(!reduce && window.matchMedia('(hover:hover) and (pointer:fine)').matches){
    var c=document.createElement('div'); c.className='pj-cursor'; c.textContent='Read'; document.body.appendChild(c);
    var x=0,y=0,tx=0,ty=0,raf=null;
    var loop=function(){ x+=(tx-x)*.18; y+=(ty-y)*.18; c.style.left=x+'px'; c.style.top=y+'px'; raf=(Math.abs(tx-x)+Math.abs(ty-y)>.5)?requestAnimationFrame(loop):null; };
    document.addEventListener('mousemove',function(e){ tx=e.clientX; ty=e.clientY; if(!raf) raf=requestAnimationFrame(loop); },{passive:true});
    [].forEach.call(root.querySelectorAll('[data-pj-read]'),function(el){
      el.addEventListener('mouseenter',function(){c.classList.add('is-on')});
      el.addEventListener('mouseleave',function(){c.classList.remove('is-on')});
    });
  }

  // Rail arrows
  [].forEach.call(root.querySelectorAll('[data-pj-rail]'),function(w){
    var rail=w.querySelector('.pj-rail');
    [].forEach.call(w.querySelectorAll('[data-dir]'),function(b){
      b.addEventListener('click',function(){ rail.scrollBy({left:(b.dataset.dir==='next'?1:-1)*rail.clientWidth*.8,behavior:'smooth'}); });
    });
  });

  // Hero parallax
  var hero=root.querySelector('.pj-hero-frame>img');
  if(hero && !reduce){
    var f=hero.parentNode, tick=false;
    var upd=function(){ var r=f.getBoundingClientRect(), p=Math.min(Math.max(-r.top/r.height,0),1); hero.style.transform='scale('+(1.06-p*.06)+') translateY('+(p*6)+'%)'; tick=false; };
    window.addEventListener('scroll',function(){ if(!tick){tick=true;requestAnimationFrame(upd)} },{passive:true}); upd();
  }

  // Safety: if animation frames are throttled, reveal everything after 2.5s
  setTimeout(function(){ root.classList.add('is-ready'); [].forEach.call(root.querySelectorAll('.pj-reveal'),function(e){ var r=e.getBoundingClientRect(); if(r.top<innerHeight) e.classList.add('is-in'); }); },2500);

  // Article enhancements
  var body=root.querySelector('[data-pj-body]');
  if(!body) return;

  // Lede drop cap on the opening paragraph (skips italic notes and "Updated" lines)
  var kids=[].slice.call(body.children).slice(0,4);
  var firstP=kids.find(function(n){ var t=n.textContent.trim(); return n.tagName==='P' && t.length>120 && !/^updated/i.test(t) && !n.querySelector('img,table') && !(n.firstElementChild && /^(EM|I)$/.test(n.firstElementChild.tagName) && n.firstElementChild.textContent.trim().length>t.length*.6); });
  if(firstP) firstP.classList.add('pj-lede');

  // Hide the article's own contents list on desktop (the sticky contents replaces it)
  [].forEach.call(body.querySelectorAll(':scope > h2'),function(h){ if(/^(contents|table of contents|in this (guide|article|story))$/i.test(h.textContent.trim())){ h.classList.add('pj-dup'); var nx=h.nextElementSibling; if(nx && /^(UL|OL|DIV|NAV)$/.test(nx.tagName)) nx.classList.add('pj-dup'); } });

  // Tables
  [].forEach.call(body.querySelectorAll('table'),function(t){
    if(t.closest('.pj-table')) return;
    var w=document.createElement('div'); w.className='pj-table pj-reveal';
    var s=document.createElement('div'); s.className='pj-table-scroll';
    t.parentNode.insertBefore(w,t); s.appendChild(t); w.appendChild(s);
    var h=document.createElement('div'); h.className='pj-table-hint'; h.innerHTML='<span aria-hidden="true">&harr;</span> Swipe for more columns'; w.appendChild(h);
    var chk=function(){ w.classList.toggle('is-scroll', s.scrollWidth>s.clientWidth+2); }; chk();
    window.addEventListener('resize',chk,{passive:true});
    if(io) io.observe(w); else w.classList.add('is-in');
  });

  // FAQ accordion
  [].forEach.call(body.querySelectorAll('h2'),function(h2){
    if(!/faq|frequently asked/i.test(h2.textContent)) return;
    var wrap=document.createElement('div'); wrap.className='pj-faq';
    var n=h2.nextElementSibling, items=[];
    while(n && n.tagName!=='H2'){
      if(n.tagName==='H3'){
        var item=document.createElement('div'); item.className='pj-faq-i';
        var a=document.createElement('div'); a.className='pj-faq-a'; var inner=document.createElement('div'); a.appendChild(inner);
        var q=n; n=n.nextElementSibling;
        while(n && n.tagName!=='H3' && n.tagName!=='H2'){ var nx=n.nextElementSibling; if(n.tagName!=='SCRIPT') inner.appendChild(n); n=nx; }
        item.appendChild(q); item.appendChild(a); items.push(item);
        q.setAttribute('role','button'); q.setAttribute('tabindex','0'); q.setAttribute('aria-expanded','false');
        (function(it,qq){ var t=function(e){ if(e.type==='keydown'&&e.key!=='Enter'&&e.key!==' ') return; e.preventDefault(); var o=it.classList.toggle('is-open'); qq.setAttribute('aria-expanded',o); }; qq.addEventListener('click',t); qq.addEventListener('keydown',t); })(item,q);
      } else { n=n.nextElementSibling; }
    }
    if(items.length){ items.forEach(function(i){wrap.appendChild(i)}); items[0].classList.add('is-open'); items[0].firstChild.setAttribute('aria-expanded','true'); h2.parentNode.insertBefore(wrap,h2.nextSibling); }
  });

  // Numbered section heads + contents
  var hs=[].slice.call(body.querySelectorAll(':scope > h2')).filter(function(h){ var t=h.textContent.trim(); return t && !/^(contents|table of contents|in this (guide|article|story))$/i.test(t); });
  hs.forEach(function(h,i){ h.setAttribute('data-n', (i<9?'0':'')+(i+1)); h.classList.add('pj-reveal'); if(io) io.observe(h); else h.classList.add('is-in'); });
  if(hs.length>=3){
    var ol=root.querySelector('[data-pj-toc]'), olm=root.querySelector('[data-pj-tocm]'), links=[];
    hs.forEach(function(h,i){
      if(!h.id) h.id=(h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')||'section')+'-'+(i+1);
      [ol,olm].forEach(function(list,k){ if(!list) return; var li=document.createElement('li'), a=document.createElement('a'); a.href='#'+h.id; a.innerHTML='<em>'+h.getAttribute('data-n')+'</em><span></span>'; a.lastChild.textContent=h.textContent.trim(); li.appendChild(a); list.appendChild(li); if(k===0) links.push(a); });
    });
    var toc=root.querySelector('.pj-toc'), tocm=root.querySelector('.pj-tocm'); if(toc) toc.hidden=false; if(tocm) tocm.hidden=false;
    if('IntersectionObserver' in window){
      var so=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) links.forEach(function(l){ l.classList.toggle('is-active', l.getAttribute('href')==='#'+e.target.id); }); }); },{rootMargin:'-25% 0px -65% 0px'});
      hs.forEach(function(h){ so.observe(h); });
    }
  }

  // Reading progress
  var bar=root.querySelector('.pj-progress i');
  if(bar){ var tk=false; var pr=function(){ var r=body.getBoundingClientRect(), tot=r.height-innerHeight*.5, d=Math.min(Math.max(-r.top+innerHeight*.25,0),tot); bar.style.transform='scaleX('+(tot>0?d/tot:0)+')'; tk=false; }; addEventListener('scroll',function(){ if(!tk){tk=true;requestAnimationFrame(pr)} },{passive:true}); pr(); }

  // Shop card: move it into the story, just before the second section (or after the third paragraph)
  var card=root.querySelector('[data-pj-shop]');
  if(card){
    var anchor=hs[1]||null;
    if(!anchor){ var ps=[].slice.call(body.querySelectorAll(':scope > p')).filter(function(p){return p.textContent.trim().length>60}); if(ps.length>4) anchor=ps[2].nextElementSibling; }
    if(anchor && anchor.parentNode===body) body.insertBefore(card,anchor);
  }

  // Sticky shop pill: shows once the reader is past the header, hides at the shop band and footer
  var st=root.querySelector('[data-pj-sticky]'), head=root.querySelector('.pj-ahead');
  if(st && head && 'IntersectionObserver' in window){
    var past=false, block=0, sync=function(){ var on=past && block===0; st.classList.toggle('is-on',on); st.setAttribute('aria-hidden',on?'false':'true'); st.tabIndex=on?0:-1; };
    new IntersectionObserver(function(es){ es.forEach(function(e){ past=!e.isIntersecting && e.boundingClientRect.top<0; }); sync(); }).observe(head);
    var seen=new Set();
    var bo=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) seen.add(e.target); else seen.delete(e.target); }); block=seen.size; sync(); },{rootMargin:'0px 0px -10% 0px'});
    [].forEach.call(root.querySelectorAll('[data-pj-shop],.pj-edit,.pj-more,.pj-sign'),function(el){ bo.observe(el); });
    var ft=document.querySelector('.shopify-section-group-footer-group')||document.querySelector('footer'); if(ft) bo.observe(ft);
  }

  // Copy link
  var cp=root.querySelector('[data-pj-copy]');
  if(cp) cp.addEventListener('click',function(){ if(navigator.clipboard) navigator.clipboard.writeText(cp.dataset.pjCopy).then(function(){ cp.setAttribute('aria-label','Link copied'); cp.style.background='#0d0d0c'; cp.style.color='#fff'; setTimeout(function(){ cp.removeAttribute('style'); cp.setAttribute('aria-label','Copy link'); },1400); }); });
})();
